export default "__VITE_ASSET__2b253fa0__"